import { useCallback, useState } from "react"
import { Item } from "../../../../../../../utils/types/generals"
import { Roles } from "../../../../../../../utils/enums"
import { getArea, getDepartments, getRoles, getUserTypes } from "../../../../../../../utils/methods/geServiceWithItemsFormat"
import { useInputList } from "./useInputList"


const useGetDataList = () => {
    const [items, setItems] = useState<{ [x: string]: Item[] }>({})
    const { input } = useInputList({ items })
    const [departments, setDepartments] = useState<any[]>([])

    const getData = useCallback(async () => {
        getUserTypesService()
        getRolesService()
        getAreasService()
        getDepartmentService()
    }, [])



    const getUserTypesService = async () => {
        const { items } = await getUserTypes()

        setItems((prev) => ({
            ...prev,
            userTypeId: items,
        }))
    }

    const getRolesService = async () => {
        const responseRoles = await getRoles({ skip: [Roles.ADMIN], all:true })

        setItems((prev) => ({
            ...prev,
            roles: responseRoles.items,
        }))
    }


    const getAreasService = async () => {
        const responseAreas = await getArea()

        setItems((prev) => ({
            ...prev,
            area: responseAreas,
        }))
    }

    const getDepartmentService = async () => {
        const departments = await getDepartments()
        setDepartments(departments)
    }

    const handleItemsByExternal = ({
        name,
        value,
    }: {
        name: string
        value: any
    }) => {
        setItems((prev) => ({
            ...prev,
            [name]: value,
        }))
    }


    return { input, getData, items, departments, handleItemsByExternal }
}

export { useGetDataList }
